import React from 'react';
function Buttons({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="9.7" height="4.7" x=".65" y="9.65" rx="1.35" />
      <rect width="9.7" height="4.7" x="13.65" y="9.65" rx="1.35" />
      <path strokeLinecap="round" d="M3 12h5" />
    </svg>
  );
}

export default Buttons;
